<div id="stocks-wrapper" class="d-flex mg-b--10 pg-t-10" [style.height.px]="utils.getScreenAvailableHeight(100)">
  <yo-search-panel></yo-search-panel>
  <div style="width: 100%;">
    <router-outlet></router-outlet>
  </div>
</div>



